import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class CookieComponent implements OnInit {

  constructor(private cookieService: CookieService) { }

    ngOnInit(): void {
        const button: HTMLElement = document.getElementById('btn-cookie');

        const cookieExists: boolean = this.cookieService.check('cb');
        const cookiecontainer = document.getElementById('cookie');
        if (!cookieExists) {
            cookiecontainer.classList.add('active');
        }

    }
    cookie(event) {
        this.cookieService.set( 'cb', '1' );
        const cookiecontainer = document.getElementById('cookie');
        cookiecontainer.classList.remove('active');
    }

}
